import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PrequalificationsEditComponent } from './prequalifications-edit/prequalifications-edit.component';
import { PrequalificationsViewComponent } from './prequalifications-view/prequalifications-view.component';
import { PrequalificationsComponent } from './prequalifications.component';
import { AuthGuard } from '../guards/auth.guard';

const routes: Routes = [
  {
    path: 'prequalifications',
    canActivate: [
      AuthGuard
    ],
    children: [
      { path: '', component: PrequalificationsComponent },
      { path: ':id/edit', component: PrequalificationsEditComponent },
      { path: ':id/view', component: PrequalificationsViewComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PrequalificationsRoutingModule {}
